import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { SpaceTab, SpaceTabDocumentType } from 'api/space/space-tab';
import { StoreActionProps } from 'data/core';
import { setupSpaceTabsOnSpaces } from 'data/templates/projects/slices';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  embedDocumentTemplateAction,
  EmbedDocumentTemplateActionPayload,
} from '../actions';
import { DocumentTemplatesAPI } from '../api';

type SpaceTabType = Pick<
  SpaceTab,
  'spaceTabId' | 'spaceTabType' | 'spaceTabTitle' | 'url' | 'metaData'
>;
function* embedDocumentTemplateSaga(
  action: StoreActionProps<EmbedDocumentTemplateActionPayload>,
) {
  const {
    payload: { spaceId, url, handleAlways, handleFailure, handleSuccess },
  } = action;

  try {
    const res = yield DocumentTemplatesAPI.embed(url);

    const spaceTabId = floatUid();
    let spaceTab: SpaceTabType = {
      spaceTabId,
      spaceTabType: SpaceTabDocumentType.EmbedableDocument,
      url,
      spaceTabTitle: url,
    };

    if (res.error && res.status === 403) {
      spaceTab = {
        ...spaceTab,
        url,
        spaceTabTitle: url,
      };
    } else {
      spaceTab = {
        ...spaceTab,
        url: res.url,
        spaceTabTitle: res.meta?.title,
        metaData: res,
      };
    }

    yield put(
      setupSpaceTabsOnSpaces({
        spaceTab,
        spaceId,
      }),
    );

    if (handleSuccess) {
      handleSuccess(spaceTabId);
    }
  } catch (error) {
    logger.log(' an error embedding a link', { error });

    message.error('There was an error embedding a link');

    if (handleFailure) {
      handleFailure();
    }
  }

  if (handleAlways) {
    handleAlways();
  }
}

export function* watchEmbedDocumentTemplateSaga(): Generator {
  yield takeLatest(embedDocumentTemplateAction.type, embedDocumentTemplateSaga);
}
